// extracted by mini-css-extract-plugin
export default {"main":"Header_main__1oMp2","mainImage":"Header_mainImage__kcjyh","header":"Header_header__bwRPy","mainContent":"Header_mainContent__EyPBZ"};